export const TOKEN_KEY = "TOKEN_KEY";
export const REFRESH_TOKEN_KEY = "REFRESH_TOKEN_KEY";
export const USER_INFO = "USER_INFO";

export const ROOT_TOKEN_KEY = "ROOT_TOKEN_KEY";
export const ROOT_REFRESH_TOKEN_KEY = "ROOT_REFRESH_TOKEN_KEY";
export const ROOT_PROFILE = "ROOT_PROFILE";
